import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
window.Stimulus = Application.start()
const context = require.context("./controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

Rails.start()
ActiveStorage.start()

// import AppareilController from "./appareil_controller"
// Stimulus.register("appareil", AppareilController)
